export const NotificationSettingsTestIds = {
  notificationSettingsContainer: 'notification_settings_container',
  deletePeriodSlider: 'deletePeriod_slider',
  inputDeletiontime: 'input_deletiontime',
  saveSettingsButton: 'saveSettings_button'
} as const;
